import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlaskVial } from '@fortawesome/free-solid-svg-icons';
import './ResearchSummary.css'; // Import the dedicated CSS file

const ResearchSummary = ({ data }) => {
  if (!data || !data.research_summary) {
    return null;
  }

  return (
    <div className="OATS-research-summary">
      <div className="OATS-research-summary-header">
        <FontAwesomeIcon icon={faFlaskVial} className="OATS-research-summary-icon" />
        <span>Research Synthesis</span>
      </div>
      <p className="OATS-research-summary-text">
        {data.research_summary}
      </p>
    </div>
  );
};

export default ResearchSummary;